import { initializeApp, getApps, type FirebaseApp } from 'firebase/app'
import { getAuth, connectAuthEmulator, type Auth } from 'firebase/auth'

const devConfig = {
  apiKey: 'AIzaSyAubC4ZX6lpf5EGEI_ki11sdwOyNw8c_C4',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'next-order-devenv.firebaseapp.com',
  databaseURL: 'https://next-order-devenv.firebaseio.com',
  projectId: 'next-order-devenv',
  storageBucket: 'next-order-devenv.appspot.com',
  messagingSenderId: '356504613086',
  appId: '1:356504613086:web:36b46ba799050839bad24f',
}

const prodConfig = {
  apiKey: 'AIzaSyBhCdHsG0sNgxnmDPyi4zBs-5PWZdYlgTY',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'next-order-prodenv.firebaseapp.com',
  databaseURL: 'https://next-order-prodenv.firebaseio.com',
  projectId: 'next-order-prodenv',
  storageBucket: 'next-order-prodenv.appspot.com',
  messagingSenderId: '81438711702',
  appId: '1:81438711702:web:bb52f7f4538e7a568987b7',
  measurementId: 'G-4NH00ESYXH',
}

const isProd = import.meta.env.VITE_APP_ENV === 'production'
const firebaseConfig = isProd ? prodConfig : devConfig

export const app: FirebaseApp =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0]

export const auth: Auth = getAuth(app)

if (import.meta.env.VITE_USE_EMULATOR === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })
}
